/**
 * Insurance provider constants shared across ShipStation applications.
 */

/** Numeric string IDs for each insurance provider. */
export const INSURANCE_PROVIDER_IDS = {
  NONE: '0',
  SHIPSURANCE: '1',
  CARRIER: '2',
  EXTERNAL: '3',
  XCOVER: '4',
  PARCELGUARD: '5',
} as const;

/** Display names for each insurance provider. */
export const INSURANCE_PROVIDER_NAMES = {
  NONE: 'None',
  SHIPSURANCE: 'Shipsurance',
  CARRIER: 'Carrier',
  EXTERNAL: 'External',
  XCOVER: 'XCover',
  PARCELGUARD: 'ParcelGuard',
} as const;

const PARCELGUARD_CLAIM_BASE_URL = 'https://app.shipsurance.com/extclaims/' as const;
const PARCELGUARD_CID = 'parcelguard' as const;

export type InsuranceProvider = {
  name: string;
  buildClaimUrl: (params: { sellerId: string; insuranceBookingId: string }) => string;
};

export const INSURANCE_PROVIDERS: Record<string, InsuranceProvider> = {
  [INSURANCE_PROVIDER_IDS.PARCELGUARD]: {
    name: INSURANCE_PROVIDER_NAMES.PARCELGUARD,
    buildClaimUrl: ({ sellerId, insuranceBookingId }) => {
      const url = new URL(PARCELGUARD_CLAIM_BASE_URL);
      url.searchParams.set('cid', PARCELGUARD_CID);
      url.searchParams.set('psid', sellerId);
      url.searchParams.set('shipmentid', insuranceBookingId);
      return url.toString();
    },
  },
};
